<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.textSubheading"
        :disabled="getMaintActivityList.length > 30"
        flat icon @click="openDialog()">
          <v-icon :color="ui.btnColor"> add </v-icon>
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Maint. Activity
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  hint="maintenance activity"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="activityTypeOptions"
                  :rules="ruleMustBeSelected"
                  prepend-icon="grid_view"
                  hint="type"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="activity id"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.discipline"
                  :items="engineeringDiscipline"
                  prepend-icon="engineering"
                  hint="discipline"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.owner"
                  :items="activityOwnerOptions"
                  hint="owner"
                  prepend-icon="person"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.driver"
                  :items="activityDriverOptions"
                  prepend-icon="admin_panel_settings"
                  hint="driver"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.comp"
                  :rules="mustBeLessThanSmallNotRequired    "
                  prepend-icon="assured_workload"
                  hint="compliance"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.scope"
                  :rules="mustBeLessThanSmallNotRequired"
                  prepend-icon="check_box_outline_blank"
                  hint="scope"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.failure"
                  :rules="mustBeLessThanSmallNotRequired"
                  prepend-icon="error_outline"
                  hint="failure modes"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.method"
                  :items="activityMethodOptions"
                  prepend-icon="adjust"
                  hint="method"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.model"
                  :items="activityModelOptions"
                  hint="model"
                  prepend-icon="model_training"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm3>
                  <v-text-field
                  v-model="localForm.frequency"
                  :rules="ruleNumberMoreThanZero"
                  prepend-icon="manage_history"
                  persistent-hint
                  hint="freq."
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                  v-model="localForm.unit"
                  :items="activityFrequencyOptions"
                  prepend-icon="event"
                  persistent-hint
                  hint="unit"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.cond"
                  :items="activityConditionOptions"
                  prepend-icon="build_circle"
                  hint="condition"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.imp"
                  :items="activityResourceImpactOptions"
                  prepend-icon="group_add"
                  hint="impact"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.coste"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="attach_money"
                  hint="cost"
                  :suffix="localForm.costu"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.carbe"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="co2"
                  :suffix="localForm.carbu"
                  hint="carbon"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Activity Scope and Justification
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="failures and rates without maintenance plan"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import activityOptions from "@/data/options/mixins/activityOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    listFunctions,
    generateForms,
    master,
    activityOptions,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getMaintActivityList",
      "getMaintActivityListCounter",
      "getDetail",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      localForm: {
        id: "MA1", // parts Id
        title: "Maintenance Activity 1", // parts title
        type: "Test",
        discipline: "Electrical", // eng. discipline
        com: "", // parts coms
        driver: "Safety", // parts
        comp: "", // hell
        scope: "",
        failure: "",
        method: "Time", // pattern
        model: "Area", // type
        frequency: "1",
        unit: "Y",
        cond: "Online",
        imp: "R0",
        coste: "1000",
        carbe: "10",
        costu: "AUD",
        carbu: "kg",
        owner: "M"
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeMaintActivityList", []);
      // this.$refs.form.reset();
    },
    refreshList() {
      let store = "changeMaintActivityListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getMaintActivityListCounter + 1);
      this.$store.dispatch(store, this.getMaintActivityListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // maintActivity removed.
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.$refs.form.validate() === true) {
        // NEW ACTIVITY
        let tempForm = this.generateMaintActivityForm();

        // BASIC
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "M1");
        tempForm.basic.idi = this.getMaintActivityListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.basic.tag = "M1";

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.discipline;
        tempForm.char.driver = this.localForm.driver;
        tempForm.char.model = this.localForm.model;
        tempForm.char.method = this.localForm.method;
        tempForm.char.freq = this.localForm.frequency;
        tempForm.char.unit = this.localForm.unit;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.com = this.localForm.com;
        tempForm.char.comp = this.localForm.comp;
        tempForm.char.scope = this.localForm.scope;
        tempForm.char.fail = this.localForm.failure;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.imp = this.localForm.imp;
        tempForm.char.coste = this.localForm.coste;
        tempForm.char.carbe = this.localForm.carbe;
        tempForm.char.owner = this.localForm.owner;
        tempForm.char.status = "C";

        // STATS
        tempForm.stats.date = moment().format();
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getMaintActivityList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 12);

        // STORE UPDATE
        this.$store.dispatch("changeMaintActivityList", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeMaintActivityListCounter", tempForm.basic.idi);
        // eslint-disable-next-line
        this.refreshList();

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
